package org.moxultimate.topwithmox.components.restricted

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.moxultimate.topwithmox.components.buttons.GradientButton
import org.moxultimate.topwithmox.components.texts.moxTextGradient
import org.moxultimate.topwithmox.navigation.rememberAppNavigator
import org.moxultimate.topwithmox.theme.DarkGrayColor
import org.moxultimate.topwithmox.theme.FontFamily
import org.moxultimate.topwithmox.theme.WhiteBG

/**
 * RestrictedPage
 * Full-page placeholder shown when a feature-toggle disables a CRUD route.
 * Renders a centred lock icon, "Page is restricted" heading, and a back-to-home button.
 */
@Composable
fun RestrictedPage() {
    val navigator = rememberAppNavigator()

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(80.vh)
            .backgroundColor(WhiteBG),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier
                .padding(all = 40.px),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(16.px),
        ) {
            SpanText(
                text = "🔒",
                modifier = Modifier
                    .fontSize(72.px),
            )

            SpanText(
                text = "Page is Restricted",
                modifier = Modifier
                    .fontFamily(FontFamily)
                    .fontSize(clamp(min = 28.px, value = 3.5.vh, max = 42.px))
                    .fontWeight(FontWeight.Bold)
                    .moxTextGradient()
                    .textAlign(TextAlign.Center),
            )

            SpanText(
                text = "This page is currently unavailable. Please check back later.",
                modifier = Modifier
                    .fontFamily(FontFamily)
                    .fontSize(16.px)
                    .fontWeight(FontWeight.Normal)
                    .color(DarkGrayColor)
                    .textAlign(TextAlign.Center)
                    .styleModifier { property("max-width", "400px") },
            )

            Box(modifier = Modifier.padding(top = 8.px)) {
                GradientButton(
                    text = "Back to Home",
                    onClick = { navigator.goToDashboard() },
                )
            }
        }
    }
}
